(function (window, document) {
  var docEl = document.documentElement;
  var designWidth = 1920; // 设计稿宽度
  var rem = 100; // 设计稿宽度为 1920px 时，根字体大小为 100px
  //   var scale = 1;

  // 根据屏幕宽度动态设置 font-size
  var updateFontSize = function () {
    var width = docEl.getBoundingClientRect().width;
    // 计算根字体大小
    docEl.style.fontSize = (width / designWidth) * rem + "px";
  };

  // 初始化根字体大小
  updateFontSize();

  // 监听窗口大小变化
  window.addEventListener("resize", updateFontSize);
})(window, document);
